import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import emailAddressWrapperToAttendeeType from '../utils/emailAddressWrapperToAttendeeType';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { ApiError, ApiErrorCode, RecipientFieldEnum } from 'owa-addins-core';
import {
    updateOptionalAttendees,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';

const MAX_RECIPIENTS_COUNT = 500;

export var getRecipients = (type: RecipientFieldEnum): EmailAddressWrapper[] => {
    const event = getComposeEvent(null /* formId */);
    let attendees: AttendeeType[];
    if (type === RecipientFieldEnum.RequiredAttendees) {
        attendees = event.RequiredAttendees;
    } else if (type === RecipientFieldEnum.OptionalAttendees) {
        attendees = event.OptionalAttendees;
    }

    if (attendees && attendees.length > 0) {
        return attendees.map(attendee => attendee.Mailbox);
    }

    return [];
};

export var setRecipients = (
    type: RecipientFieldEnum,
    newRecipients: EmailAddressWrapper[]
): void => {
    if (newRecipients.length > MAX_RECIPIENTS_COUNT) {
        throw new ApiError(ApiErrorCode.NumberOfRecipientsExceeded);
    }

    const attendees = emailAddressWrapperToAttendeeType(newRecipients);
    if (type === RecipientFieldEnum.RequiredAttendees) {
        updateRequiredAttendees(attendees);
    } else if (type === RecipientFieldEnum.OptionalAttendees) {
        updateOptionalAttendees(attendees);
    }
};

export var addRecipients = (
    type: RecipientFieldEnum,
    newRecipients: EmailAddressWrapper[]
): void => {
    let recipients = getRecipients(type);
    recipients = recipients.concat(newRecipients);
    setRecipients(type, recipients);
};
